export const HANDLE_TYPE_CONSTANTS = {
	TICKET: 'TICKET',
	ORDER: 'PEDIDO',
	TRIP: 'VIAGEM',
	CAMPAIGN: 'CAMPANHA',
}
